import React from "react";
import Icon from "@mdi/react";
import { mdiChevronUp } from "@mdi/js";
import { cn } from "@heroui/react";

interface SortableColumnHeaderProps {
  children: React.ReactNode;
  sortDirection?: "ascending" | "descending";
}

const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({
  children,
  sortDirection,
}) => (
  <span className="sc-sortable-header" data-testid="sortable-column-header">
    {children}
    {!!sortDirection && (
      <Icon
        path={mdiChevronUp}
        size={0.55}
        className={cn(
          "sc-sortable-header__icon",
          sortDirection === "descending" && "sc-sortable-header__icon--desc",
        )}
      />
    )}
  </span>
);

SortableColumnHeader.displayName = "SortableColumnHeader";

export default SortableColumnHeader;
